import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import AIAgentDocumentEmbedPanel from './AIAgentDocumentEmbedPanel';

export default function AIAgentDocumentFormModal({
  open,
  draft,
  onClose,
  onDocumentSaved,
  lightSurface = false,
}) {
  const { t } = useTranslation();
  const p = (key, opts) => t(`modules.shared.aiAgent.documentFormModal.${key}`, opts);

  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open || !draft) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center p-3 sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-label={p('dialog_aria')}
    >
      <button
        type="button"
        className="absolute inset-0 bg-slate-950/80 backdrop-blur-sm border-0 cursor-default"
        onClick={onClose}
        aria-label={p('close_backdrop_aria')}
      />
      <div
        className={`relative z-10 flex h-[min(92vh,920px)] w-full max-w-[min(96vw,1440px)] flex-col overflow-hidden rounded-2xl border shadow-2xl ${
          lightSurface
            ? 'border-gray-200 bg-white'
            : 'border-white/20 bg-gradient-to-br from-slate-900 via-blue-950 to-slate-900 shadow-blue-950/40'
        }`}
      >
        <AIAgentDocumentEmbedPanel
          variant="modal"
          draft={draft}
          onClose={onClose}
          onDocumentSaved={onDocumentSaved}
          lightSurface={lightSurface}
        />
      </div>
    </div>,
    document.body,
  );
}
